import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Box, Typography } from '@mui/material';
import { Event } from '@mui/icons-material';

import { moment } from '../../../../I18n';
import useWidth from '../../../../Hooks/useWidth';

function EventDates({ post }: any) {
  const intl = useIntl();
  let periodI18nStringID;

  if (moment(post.start_at).isSame(post.end_at, 'day')) {
    periodI18nStringID = 'POSTS.TAGS.PERIOD_SAME_DAY';
  } else {
    periodI18nStringID = useWidth('down', 'sm') ? 'POSTS.TAGS.PERIOD_SHORT' : 'POSTS.TAGS.PERIOD';
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'nowrap',
        mb: 1,
        gap: 2,
      }}
    >
      <Box sx={{ display: 'flex' }}>
        <Event color="action" />
      </Box>
      <Typography
        variant="body2"
        color="textSecondary"
        sx={{
          fontWeight: 'fontWeightMedium',
        }}
      >
        <FormattedMessage
          id={periodI18nStringID}
          values={{
            startAtDate: moment(post.start_at).format(
              intl.formatMessage({ id: 'MOMENT.DATE.DEFAULT' }),
            ),
            startAtHour: moment(post.start_at).format('LT'),
            endAtDate: moment(post.end_at).format(
              intl.formatMessage({ id: 'MOMENT.DATE.DEFAULT' }),
            ),
            endAtHour: moment(post.end_at).format('LT'),
            strong: (...chunks: any[]) => chunks,
          }}
        />
      </Typography>
    </Box>
  );
}

export default EventDates;
